import { DEFAULT_START_DATE, DEFAULT_END_DATE } from "../shared/constants";
import { allIndices } from "./CalculatorInputs";


export interface DatesModel{
    startYear: number;
    endYear: number;
}
export interface SelectedDateModel{
    selectedDate: number;
    investmentIdentifier: string;
}

export class DatePresetsModel {
    dateModelsByIndexCode: Map<string, DatesModel>;
    selectedDateModel?: SelectedDateModel;
    hasError?: boolean;
    constructor(dateModelsByIndexCode: Map<string, DatesModel>, selectedDateModel?: SelectedDateModel, hasError?: boolean){
        this.dateModelsByIndexCode = dateModelsByIndexCode;
        this.selectedDateModel = selectedDateModel;
        this.hasError = hasError;
    }
    withSelectedDateModel(selectedDateModel: SelectedDateModel | undefined){
        return new DatePresetsModel(this.dateModelsByIndexCode, selectedDateModel);
    }
    withFetchError(hasError: boolean){
        return new DatePresetsModel(this.dateModelsByIndexCode, this.selectedDateModel, hasError);
    }

}

export const defaultDatesModel = {startYear:DEFAULT_START_DATE, endYear: DEFAULT_END_DATE};
export const defaultDatesModelMap = new Map<string, DatesModel>();
for (const index of allIndices) {
    defaultDatesModelMap.set(index.code, defaultDatesModel);
}
export const defaultDatePresetsModel = new DatePresetsModel(defaultDatesModelMap, undefined, false);

export const getYearList = (startYear: number, endYear: number) => {
        const currentYear = new Date(endYear,1,1).getFullYear(), years = [];
        startYear = startYear || DEFAULT_START_DATE;  
        while ( startYear <= currentYear ) {
            years.push(startYear++);
        }   
        return years;
    
}